import { PropType } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';

type Props = SetupProps<typeof SharedSelectAssigneeSetupService.props>
type Emits = {(e: 'update:modelValue' | 'input', val: Undef<number>): void};

export default class SharedSelectAssigneeSetupService extends BaseSetupService<Props> {
	static readonly props = {
		modelValue: {
			type: Number,
			default: undefined,
		},
		options: {
			type: Array as PropType<IUserAgencyForListModel[]>,
			required: true as const,
		},
	};

	private emits: Emits;

	get userId () { return this.props.modelValue; };
	set userId (val) {
		this.emits('update:modelValue', val);
		this.emits('input', val);
	}

	constructor (props: Props, emits: Emits) {
		super(props);
		this.emits = emits;
	}
}
